module.exports = __webpack_public_path__ + "img/cad6f75.jpg";